// * Redis keys
// ! DO NOT TOUCH BELOW CONSTANTS

// Categories
export const CACHE_EXPIRES_IN_ONE_DAY = 10800 // 3 hours
export const CACHE_EXPIRES_IN_THREE_DAYS = 86400 // 1 day
export const CACHE_EXPIRES_IN_ONE_WEEK = 604800 // 1 week

export const CACHE_MENU_COLLECTIONS = "menu-collections"
export const CACHE_PAGE_BRANDS = "brands"
export const CACHE_HOME_PAGE = "home:cms:page"
export const CACHE_SEARCH_DATA = "root:search:data"
export const EXPRESS_FILTER_ID = "13237"
export const NIGHT_FILTER_ID = "24845"
export const IS_PUBLIC_YES_FILTER_ID = "19638"

export const PAYMENT_METHODS = [
  "bank-transfer",
  "qpay",
  "omniway",
  "storepay",
  "pocket",
  "lendpay",
  "pass",
  "mostmoney",
  "superup",
  "toki",
  "socialpay",
  "golomtbank",
  "khanbank",
]

export const DEFAULT_PRICE_LOCATIONKEY = "2007121500003"
